import * as React from "react";

import { createSvgIcon } from "@mui/material/utils";

const Achievement10Icon = createSvgIcon(
    <svg
        width="160"
        height="160"
        viewBox="0 0 160 160"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M76.6223 158.427L33.9378 135.097C19.1794 127.03 10 111.552 10 94.7326V6C10 2.68629 12.6863 0 16 0H43H79.5H116H143C146.314 0 149 2.6863 149 6V94.7326C149 111.552 139.821 127.03 125.062 135.097L82.3777 158.427C80.5844 159.407 78.4156 159.407 76.6223 158.427Z"
            fill="url(#paint0_linear_5305_1588)"
        />
        <g filter="url(#filter0_i_5305_1588)">
            <path
                d="M76.6129 141.415L48.8659 126.185C34.1476 118.106 25 102.65 25 85.8603V23C25 19.6863 27.6863 17 31 17H50.8777H79.5H108.122H128C131.314 17 134 19.6863 134 23V85.8603C134 102.65 124.852 118.106 110.134 126.185L82.3871 141.415C80.5889 142.402 78.4111 142.402 76.6129 141.415Z"
                fill="url(#paint1_linear_5305_1588)"
            />
        </g>
        <path
            d="M76.6129 141.415L48.8659 126.185C34.1476 118.106 25 102.65 25 85.8603V23C25 19.6863 27.6863 17 31 17H50.8777H79.5H108.122H128C131.314 17 134 19.6863 134 23V85.8603C134 102.65 124.852 118.106 110.134 126.185L82.3871 141.415C80.5889 142.402 78.4111 142.402 76.6129 141.415Z"
            stroke="#182370"
            strokeWidth="3"
        />
        <g filter="url(#filter1_d_5305_1588)">
            <path
                d="M78.2065 42.634C78.9402 41.1475 81.0598 41.1475 81.7935 42.634L88.9392 57.1128C89.2305 57.7031 89.7937 58.1123 90.4451 58.2069L106.423 60.5287C108.064 60.7671 108.719 62.783 107.532 63.9401L95.9698 75.2103C95.4985 75.6698 95.2834 76.3318 95.3946 76.9806L98.1241 92.8944C98.4043 94.5282 96.6894 95.7742 95.2222 95.0028L80.9307 87.4893C80.348 87.183 79.652 87.183 79.0693 87.4893L64.7778 95.0028C63.3106 95.7742 61.5957 94.5282 61.8759 92.8944L64.6054 76.9806C64.7166 76.3318 64.5015 75.6698 64.0302 75.2103L52.4681 63.9401C51.2811 62.783 51.9361 60.7671 53.5765 60.5287L69.5549 58.2069C70.2063 58.1123 70.7695 57.7031 71.0608 57.1128L78.2065 42.634Z"
                fill="url(#paint2_linear_5305_1588)"
            />
            <path
                d="M78.8789 42.9658C79.3088 42.0948 80.5004 42.0404 81.0254 42.8027L81.1211 42.9658L88.2666 57.4443C88.6422 58.2053 89.3463 58.7479 90.1709 58.9199L90.3369 58.9492L106.315 61.2705C107.277 61.4102 107.697 62.5269 107.134 63.2617L107.009 63.4033L95.4463 74.6729C94.8386 75.2652 94.5405 76.1029 94.6318 76.9404L94.6553 77.1074L97.3848 93.0215C97.5488 93.9788 96.6169 94.7233 95.7441 94.415L95.5713 94.3389L81.2793 86.8252C80.5283 86.4305 79.6401 86.4055 78.8721 86.751L78.7207 86.8252L64.4287 94.3389C63.5691 94.7907 62.5738 94.1349 62.5967 93.21L62.6152 93.0215L65.3447 77.1074C65.4882 76.2711 65.2369 75.4188 64.6709 74.7949L64.5537 74.6729L52.9912 63.4033C52.2959 62.7255 52.6123 61.5756 53.499 61.3115L53.6846 61.2705L69.6631 58.9492C70.5028 58.8271 71.236 58.3249 71.6543 57.5938L71.7334 57.4443L78.8789 42.9658Z"
                stroke="#182370"
                strokeWidth="1.5"
            />
        </g>
        <defs>
            <filter
                id="filter0_i_5305_1588"
                x="23.5"
                y="15.5"
                width="116"
                height="132.156"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="4" dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                />
                <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow_5305_1588"
                />
            </filter>
            <filter
                id="filter1_d_5305_1588"
                x="46.8619"
                y="35.5191"
                width="68.2761"
                height="65.7178"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="1" />
                <feGaussianBlur stdDeviation="3" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_5305_1588"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_5305_1588"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear_5305_1588"
                x1="10"
                y1="0"
                x2="168.978"
                y2="141.565"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#586EC3" />
                <stop offset="1" stopColor="#0C1779" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_5305_1588"
                x1="25"
                y1="17"
                x2="149.688"
                y2="124.865"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#2E4898" />
                <stop offset="1" stopColor="#122181" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_5305_1588"
                x1="126.545"
                y1="103"
                x2="62.8571"
                y2="17.1799"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#4E64D5" />
                <stop offset="1" stopColor="#8199E6" />
            </linearGradient>
        </defs>
    </svg>,
    "Achievement10Icon",
);

export default Achievement10Icon;
